import { Accessibility } from '@mui/icons-material'
import OrganizationCreate from './OrganizationCreate'
import OrganizationEdit from './OrganizationEdit'
import OrganizationList from './OrganizationList'

const organizationIndex = {
  icon: Accessibility,
  edit: OrganizationEdit,
  create: OrganizationCreate,
  list: OrganizationList,
}

export default organizationIndex
